import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-schemaChange",
  "use": "icon-map-schemaChange-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-map-schemaChange\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.77816 4.22184L12 1L15.2218 4.22184H19.7782V8.77818L23 12L19.7782 15.2218V19.7782H15.2218L12 23L8.77819 19.7782H4.22183V15.2218L1 12L4.22183 8.77817V4.22184H8.77816ZM18 12C18 15.3137 15.3137 18 12 18V6C15.3137 6 18 8.68629 18 12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol